/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '../environments/environment';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(private auth: AngularFireAuth) {}

  ngOnInit() {
    // this.analytics.trackPageViews();

    // eslint-disable-next-line no-console
    console.log(environment.production ? 'production' : 'dev');

    // this.auth.authState.subscribe((u) => {
    //   if (environment.emulator && environment.emulatorEnabled) {
    //     this.auth.app.then((app) => {
    //       const {host, firestorePort} = environment.emulator;
    //       app.firestore().useEmulator(host, firestorePort);
    //     });
    //   }
    // });
  }
}
